import React from 'react'
import {Col, Row} from "react-bootstrap";

const makeCaption = ({captionLevels}) => {
  const captionData = [
    {value: captionLevels[0], style: styles.purpleStatus},
    {value: captionLevels[1], style: styles.blueStatus},
    {value: captionLevels[2], style: styles.greenStatus},
    {value: captionLevels[3], style: styles.yellowStatus},
    {value: captionLevels[4], style: styles.orangeStatus},
    {value: captionLevels[5], style: styles.redStatus}
  ]

  return <Row className="d-flex justify-content-around align-self-center">
    {captionData.map((caption, index) => {
      return (
        <Row className="d-flex justify-content-center align-items-center" key={index}>
          <Col className="mb-3 mr-2">
            <div style={{ ...caption.style }}></div>
          </Col>
          <Col>
            <p className="text-center">{caption.value}</p>
          </Col>
        </Row>
      )
    })
    }
  </Row>
}

const styles = {
  purpleStatus: {
    backgroundColor: '#885AF8',
    width: 15,
    height: 15,
    borderRadius: 3
  },
  blueStatus: {
    backgroundColor: '#109CF1',
    width: 15,
    height: 15,
    borderRadius: 3
  },
  greenStatus: {
    backgroundColor: '#2ED47A',
    width: 15,
    height: 15,
    borderRadius: 3
  },
  yellowStatus: {
    backgroundColor: '#F2E14C',
    width: 15,
    height: 15,
    borderRadius: 3
  },
  orangeStatus: {
    backgroundColor: '#FFB946',
    width: 15,
    height: 15,
    borderRadius: 3
  },
  redStatus: {
    backgroundColor: '#F7685B',
    width: 15,
    height: 15,
    borderRadius: 3
  }
}

export default makeCaption



// WEBPACK FOOTER //
// ./src/component/Caption/Caption.js